import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { useMarketingTypeModel } from "../allMemberMarketingTypeModel";
import { YhBox } from "@src/components/YhBox";
import { YhAuth } from "@src/components/auth/YhAuth";
import { EditModeType } from "@src/types/FmsTypes";

export const DataBox = () => {
    const { onReset, setDrawerVisible, setEditType} = useMarketingTypeModel();
    const onDetail = (type: EditModeType) => {
            setDrawerVisible(true)
            setEditType(type)
        }


    const action = (
        <>
            <YhAuth resCode="portal2.am.type.ad">
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => onDetail('add')}
                >新增</Button>
            </YhAuth>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onReset}
            >刷新</Button>
        </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}